class Language {
	#app;
	#languages = null;
	#code = 'en';
	static #instance;
	constructor() {
		if (Language.#instance) {
			return Language.#instance
		}
		Language.#instance = this;
	}
	_l(key)
	{
		let lags = this.getLanguages();
		if(typeof lags[key] !== 'undefined'){
			return lags[key];
		}
		console.error(`Unknown language code "${key}"`)
		return key;
	}
	getCodes()
	{
		return Object.keys(this.getLanguages())
	}
	setLanguage(code)
	{
		if (this.getCodes().includes(code)){
			this.#code = code;
		}
		console.error(`Unknown language code "${code}"`)
	}


	#initLanguages()
	{
		const context = this;
		context.#languages = getLanguagesData();
		return;

		 this.#app.config.globalProperties.$resource.languages().getPermissions()
			.then(function(response) {
				context.#languages = response.data?.data;
				if(!context.#languages){
					context.#languages = {};
				}
			})
			.catch(err => console.error(err));

	}

	getLanguages()
	{
		if(!this.#languages){
			this.#initLanguages();
		}
		return this.#languages;
	}

	install(app)
	{
		this.#app = app;
		app.config.globalProperties.$language = this;
	}


	static getInstance() {
		return new Language();
	}
}
function getLanguagesData()
{
	return {
		'main.text_back': 'Назад',
		'main.text_delete': 'Удалить',
		'main.text_update': 'Обновить',
		'main.text_edit': 'Редактировать',
		'main.text_create': 'Создать',
		'main.text_actions': 'Действия',
		'main.text_save': 'Сохранить',

		'menu.link_main': 'Главная',
		'menu.link_sign_in': 'Войти',
		//'menu.link_sign_in': 'Sign In',
		'menu.link_users': 'Пользователи',
		'menu.link_events': 'События',

		'sign_in.title': 'Authorize page',
		'sign_in.you_are_auth': 'You are authorized',
		'sign_in.text_sign_up': 'Sign up',
		'sign_in.text_sign_in': 'Sign in',



		'events.field_title': 'Заголовок',
		'events.field_description': 'Описание',
		'events.field_date': 'Дата',


		'events.text_create': 'Создать событие',
		'events.text_update': 'Обновить событие',

		'events.text_action_create_bet': 'Сделать ставку',
		'events.text_action_set_date': 'Задать дату',
		'events.text_action_change_date': 'Изменить дату',

		'events.set_date_header': 'Задать дату состоявшегося события <i>"{title}"</i> и вычислить победителя для события?',


		'bets.text_event_date': 'Дата события: ',
		'bets.text_no_bets': 'Ставки сделаны! Ставок больше нет!',
		'bets.text_event_is_not_arrived': 'Дата события: Пока ждем',
		'bets.text_create': 'Сделать ставку',
		'bets.text_update': 'Обновить ставку',
		'bets.text_last_winners': 'Последние победители',
		'bets.events.field_title': 'Событие',
		'bets.welcome': 'При любых обстоятельствах Вика с Рыжей поют',


		'bets.status_waiting': 'пока ждем',
		'bets.status_win': 'сыграла',
		'bets.status_lose': 'мимо',

		'bets.field_user_name': 'Имя пользователя',
		'bets.field_title': 'Заголовок',
		//'bets.field_title': 'Имя пользователя',
		'bets.field_status': 'Статус',
		'bets.field_bet_date': 'Дата',
		'bets.field_comments': 'Комментарий',

		'users.text_create': 'Создать пользователя',
		'users.text_update': 'Обновить пользователя',

		'users.text_name': 'Name',
		//'users.text_login': 'Login',
		'users.text_login': 'Логин',
		//'users.text_password': 'Password',
		'users.text_password': 'Пароль',

		'users.field_name': 'Имя',
		'users.field_username': 'Логин',
		'users.field_roles': 'Роли',
		'users.field_password': 'Пароль',
		'users.field_created_at': 'Дата создания',
		'users.field_updated_at': 'Дата обновления',




		'sign_up.title': 'Sing up page',
		'': '',
	};
}

export default Language